import axios from "axios/index";
import qs from 'qs';

export default {
  addNotificationHandler: ({commit}, payload) => {
    commit('ui/SHOW_OVERLAY', true, {root: true});
    axios({
      url: '/engine/notifications/handlers',
      method: "POST",
      data: qs.stringify(payload),
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    })
      .then((response) => {
        commit('ui/HIDE_OVERLAY', true, {root: true});
        commit('notifications/ADD_NOTIFICATION_HANDLER', response.data, {root: true});
      })
      .catch(err => {
        commit('ui/HIDE_OVERLAY', true, {root: true});
        /* eslint-disable */
        console.log(err);
      });
  },
  deleteNotificationHandler: ({commit}, channel) => {
    commit('ui/SHOW_OVERLAY', true, {root: true});
    axios({
      url: '/engine/notifications/handlers/' + channel,
      method: "DELETE",
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then(() => {
        commit('ui/HIDE_OVERLAY', true, {root: true});
        commit('notifications/DELETE_NOTIFICATION_HANDLER', channel, {root: true});
      })
      .catch(err => {
        commit('ui/HIDE_OVERLAY', true, {root: true});
        /* eslint-disable */
        console.log(err);
      });
  },
};